export default "__VITE_ASSET__CyOyvGP4__"